import React from 'react'
import { Router } from './router'
import 'flag-icons/css/flag-icons.min.css';
const App = () => {
  return <Router />
}

export default App
